module.exports = __webpack_public_path__ + "static/media/ibd_arm1.e984d447.png";